$(function() {
  
 $('.tab-conten1').show();
  $('.tab-content').hide();
  
  $('.tab1').click(function() {
    // Then show div on click.
    $('.tab-content1').show();
    $('.tab-content2').hide();
    $('.tab-content3').hide();
    $('.tab-content4').hide();
    $('.tab-content5').hide();
    $(this).addClass("active");
    $('.tab2').removeClass("active");
    $('.tab3').removeClass("active"); 
    $('.tab4').removeClass("active"); 
    $('.tab5').removeClass("active"); 
  });
  $('.tab2').click(function() {
    // Then show div on click.
    $('.tab-content2').show();
    $('.tab-content1').hide();
    $('.tab-content3').hide();
    $('.tab-content4').hide();
    $('.tab-content5').hide();
    $(this).addClass("active");
    $('.tab1').removeClass("active");
    $('.tab3').removeClass("active"); 
    $('.tab4').removeClass("active"); 
    $('.tab5').removeClass("active"); 
  });
  $('.tab3').click(function() {
    // Then show div on click.
    $('.tab-content3').show();
    $('.tab-content1').hide();
    $('.tab-content2').hide();
    $('.tab-content4').hide();
    $('.tab-content5').hide();
    $(this).addClass("active");
    $('.tab1').removeClass("active");
    $('.tab2').removeClass("active"); 
    $('.tab4').removeClass("active"); 
    $('.tab5').removeClass("active"); 
  });
  $('.tab4').click(function() {
    // Then show div on click.
    $('.tab-content4').show();
    $('.tab-content1').hide();
    $('.tab-content2').hide();
    $('.tab-content3').hide();
    $('.tab-content5').hide();
    $(this).addClass("active");
    $('.tab1').removeClass("active");
    $('.tab2').removeClass("active"); 
    $('.tab3').removeClass("active"); 
    $('.tab5').removeClass("active"); 
  });
  $('.tab5').click(function() {
    // Then show div on click.
    $('.tab-content5').show();
    $('.tab-content1').hide();
    $('.tab-content2').hide();
    $('.tab-content3').hide();
    $('.tab-content4').hide();
    $(this).addClass("active");
    $('.tab1').removeClass("active");
    $('.tab2').removeClass("active"); 
    $('.tab3').removeClass("active"); 
    $('.tab4').removeClass("active"); 
  })
})

 $(document).ready(function () {
                    $(".tab-content1").show();
   $('.tab1').addClass("active");
                });

